import { useState, useCallback } from 'react'

export type ContextMenuId = 'boards' | 'assets' | null

export function useContextMenusManager() {
  const [activeContextMenu, setActiveContextMenu] = useState<ContextMenuId>(null)

  const handleContextMenuStateChange = useCallback((menuId: ContextMenuId, isOpen: boolean) => {
    if (isOpen) {
      setActiveContextMenu(menuId)
    } else if (activeContextMenu === menuId) {
      setActiveContextMenu(null)
    }
  }, [activeContextMenu])

  const isContextMenuOpen = useCallback((menuId: ContextMenuId) => {
    return activeContextMenu === menuId
  }, [activeContextMenu])

  return {
    handleContextMenuStateChange,
    isContextMenuOpen,
    activeContextMenu
  }
} 